import { FormContainer } from 'components';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import { DownloadContent } from 'modules/onboarding/common/components/DownloadContent';

import {
  SigningContractFormType,
  FormErrors,
  getSchema,
} from '../../forms/signingContractForm';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {
  initialValues?: SigningContractFormType;
  canGoBack?: boolean;
  formError?: FormErrors;
  submitDisabled?: boolean;
  submitLoading?: boolean;
  contractFileHref: string;
  onSubmit: (values: SigningContractFormType) => void;
  onGoBack?: () => void;
}

export const SigningContract = ({
  initialValues,
  canGoBack,
  onGoBack,
  submitLoading,
  submitDisabled,
  formError,
  onSubmit,
  contractFileHref,
  ...formProps
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema();

  return (
    <FormContainer
      canGoBack={canGoBack}
      initialErrors={formError}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      subTitle={t('onboarding.legalSigningContract.subtitle')}
      title={t('onboarding.legalSigningContract.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <Stack spacing={32}>
        <DownloadContent
          href={contractFileHref}
          title={t('onboarding.legalSigningContract.downloadDocument')}
        />
        <FormContent {...formProps} />
      </Stack>
    </FormContainer>
  );
};
